import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "routeLine" }
const _hoisted_2 = { class: "routeLine__info" }
const _hoisted_3 = { class: "routeLine__info__item routeLine__info__item--rail" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "routeLine__line" }, [
  /*#__PURE__*/_createVNode("div", { class: "iconTrain" })
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rail_services = _resolveComponent("rail-services")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.calculateTravelTime(_ctx.item.departureTime.value, _ctx.item.arrivalTime.value)), 1)
    ]),
    _hoisted_4,
    _createVNode(_component_rail_services)
  ]))
}